import { Table, Group, ActionIcon, Tooltip, Text, Badge } from '@mantine/core';
import { IconEdit, IconTrash, IconBarbell, IconClipboardCheck } from '@tabler/icons-react';
import type { User } from '@ironlogic4/shared/types/users';
import { useNavigate } from 'react-router-dom';

interface ClientRowProps {
  client: User;
  onEdit: (client: User) => void;
  onDelete: (client: User) => void;
  programNameMap: Record<string, string>;
}

export function ClientRow({ client, onEdit, onDelete, programNameMap }: ClientRowProps) {
  const navigate = useNavigate();

  // Get program name from dictionary
  const programName = client.programId ? programNameMap[client.programId] : null;

  const handleManageBenchmarks = () => {
    navigate(`/clients/${client.id}/benchmarks`);
  };

  const handleViewAttendance = () => {
    navigate(`/clients/${client.id}/attendance`);
  };

  return (
    <Table.Tr>
      <Table.Td>
        <Group gap="xs" align="center">
          <Text fw={500}>
            {client.firstName} {client.lastName}
          </Text>
          {client.status === 'invited' && (
            <Badge variant="light" color="yellow" size="sm">
              Invited
            </Badge>
          )}
        </Group>
      </Table.Td>
      <Table.Td>{client.email}</Table.Td>
      <Table.Td>
        {programName ? (
          <Badge variant="light" color="forestGreen">
            {programName}
          </Badge>
        ) : (
          <Text size="sm" c="dimmed">
            No program
          </Text>
        )}
      </Table.Td>
      <Table.Td>
        {client.currentBenchmarks?.length || 0} current / {client.historicalBenchmarks?.length || 0} historical
      </Table.Td>
      <Table.Td>
        {client.createdAt ? new Date(client.createdAt).toLocaleDateString() : 'N/A'}
      </Table.Td>
      <Table.Td>
        <Group gap="xs">
          <Tooltip label="Manage Benchmarks">
            <ActionIcon
              variant="light"
              color="forestGreen"
              onClick={handleManageBenchmarks}
            >
              <IconBarbell size={16} />
            </ActionIcon>
          </Tooltip>
          <Tooltip label="View Attendance">
            <ActionIcon
              variant="light"
              color="forestGreen"
              onClick={handleViewAttendance}
            >
              <IconClipboardCheck size={16} />
            </ActionIcon>
          </Tooltip>
          <Tooltip label="Edit Client">
            <ActionIcon
              variant="light"
              color="forestGreen"
              onClick={() => onEdit(client)}
            >
              <IconEdit size={16} />
            </ActionIcon>
          </Tooltip>
          <Tooltip label="Delete Client">
            <ActionIcon
              variant="light"
              color="red"
              onClick={() => onDelete(client)}
            >
              <IconTrash size={16} />
            </ActionIcon>
          </Tooltip>
        </Group>
      </Table.Td>
    </Table.Tr>
  );
}